import React, { useState } from "react"

import { useAiIssueCatchStore } from "../../../../../@shared/stores/sidebarStore"

export function AiIssueCatchTab({
  selected,
  onSelect,
}: {
  selected: boolean
  onSelect: () => void
}) {
  const [tooltipVisible, setTooltipVisible] = useState(false)

  const handleTooltipToggle = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation()
    setTooltipVisible(!tooltipVisible)
  }

  return (
    <a
      title="AI 이슈 캐치"
      className={selected ? "on" : undefined}
      onClick={(e) => {
        e.preventDefault()
        onSelect()
      }}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",
        width: "44%",
        cursor: "pointer",
      }}
    >
      AI 이슈 캐치
      <span
        style={{
          position: "relative",
          backgroundColor: "#fff",
          color: "#212631",
          width: "18px",
          height: "18px",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "12px",
          lineHeight: 1,
          cursor: "pointer",
          flexShrink: 0,
        }}
        onClick={handleTooltipToggle}
      >
        ?
        <Tooltip text="오늘장 실시간 이슈&섹터" visible={tooltipVisible} />
      </span>
    </a>
  )
}

export function ContentExpandToggle() {
  const { isOpen, toggleIsOpen } = useAiIssueCatchStore() as {
    isOpen: boolean
    toggleIsOpen: () => void
  }

  return (
    <a
      title={isOpen ? "접기" : "펼치기"}
      onClick={(e) => {
        e.preventDefault()
        toggleIsOpen()
      }}
      style={{
        width: "12%",
        cursor: "pointer",
      }}
    >
      <span
        style={{
          display: "block",
          borderLeft: "solid 1px currentColor",
          borderTop: "solid 1px currentColor",
          rotate: isOpen ? "225deg" : "45deg",
          translate: isOpen ? "0 -2px" : "0 2px",
          width: "7px",
          height: "7px",
        }}
      />
    </a>
  )
}

export const AI_IFRAME_HEIGHT_OPEN = 244
export const AI_IFRAME_HEIGHT_CLOSED = 136
export const AI_FRAME_PADDING_X = 6
export const AI_FRAME_PADDING_Y = 6

export function AiIssueCatchBody() {
  const { isOpen } = useAiIssueCatchStore() as { isOpen: boolean }

  const iframeStyle = (visible: boolean): React.CSSProperties => ({
    width: "100%",
    border: 0,
    display: visible ? "block" : "none",
  })

  return (
    <div
      style={{
        padding: `${AI_FRAME_PADDING_Y}px ${AI_FRAME_PADDING_X}px`,
        backgroundColor: "#d0d0d0",
        boxSizing: "border-box",
      }}
    >
      {/* 흰 배경 + 라운드로 숏폼 테이블과 동일한 톤 */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "0.4em",
          overflow: "hidden",
          fontSize: 0,
          lineHeight: 0,
        }}
      >
        {/* 확장 상태 iframe */}
        <iframe
          title="ai-issue-catch-open"
          src="https://img.wownet.co.kr/html/pc_7.html"
          height={AI_IFRAME_HEIGHT_OPEN}
          scrolling="no"
          style={iframeStyle(isOpen)}
        />
        {/* 축소 상태 iframe */}
        <iframe
          title="ai-issue-catch-closed"
          src="https://img.wownet.co.kr/html/pc_5.html"
          height={AI_IFRAME_HEIGHT_CLOSED}
          scrolling="no"
          style={iframeStyle(!isOpen)}
        />
      </div>
    </div>
  )
}

// 툴팁: ? 아이콘 기준으로 바로 위에 표시
const Tooltip = ({ text, visible }: { text: string; visible: boolean }) => {
  return (
    <div
      style={{
        visibility: visible ? "visible" : "hidden",
        opacity: visible ? 1 : 0,
        transition: "opacity 0.3s",
        position: "absolute",
        bottom: "calc(100% + 8px)",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#555",
        color: "#fff",
        textAlign: "center",
        borderRadius: "6px",
        padding: "5px 8px",
        width: "160px",
        fontSize: "12px",
        lineHeight: 1.3,
      }}
    >
      {text}
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          borderWidth: "5px",
          borderStyle: "solid",
          borderColor: "#555 transparent transparent transparent",
        }}
      />
    </div>
  )
}
